import React, { useEffect, useState, useMemo } from 'react'
import GridSearchTemplate from '../../../pages/GridSearchTemplate'
import { DatePicker } from '../../shared/DatePicker'
import { useTextResources } from '../../../language'
import { Form } from 'semantic-ui-react'
import HotelsDropDown from '../../shared/HotelsDropDown'
import { GetAddonsByReservationReport } from '../../../api/services/finance';
import Moment from 'moment'
import { extendMoment } from 'moment-range';
const moment = extendMoment(Moment);
import PropTypes from 'prop-types'
import _ from 'lodash'
import { GetHotels } from '../../../api/services/organization'
import { onError } from '../../shared/messages'
import { dateFormat, dateFormatShort } from '../../shared/constants'

const AddonsForecastReport = ({ HotelID }) => {
    const text = useTextResources()
    const [searchState, setSearchState] = useState({})
    const [data, setData] = useState([])
    const [hotels, setHotels] = useState([])
    const days = 10

    useEffect(() => {
        (async () => {
            try {
                const hotels = await GetHotels()
                setHotels(hotels)
            } catch (error) {
                onError(error)
            }
        })()
    }, [HotelID])

    const onSearchChange = (search) => {
        if (!search.StartDate) {
            search.StartDate = moment().startOf("day").toDate();
        }
        setSearchState(search)
    }

    const onSearchComplete = (data, searchState) => {
        setSearchState(searchState)
        const range = moment.range(moment(searchState.StartDate), moment(searchState.StartDate).add(days, "days"));
        let totalAddonQuantity = 0;
        let addons = _.groupBy(data, x => x.Name)
        let newData = _.map(addons, (value, key) => {
            let newRow = {
                "Description": key,
            }
            for (let date of range.by("day")) {
                var currentAddons = data.filter(obj => moment(obj.Date).isSame(date.clone(), "day") && obj.Name === key);
                currentAddons.map(currentAddon => {
                    totalAddonQuantity += currentAddon.AdultQuantity + currentAddon.ChildQuantity + currentAddon.Quantity
                })
                newRow[date.format(dateFormat)] = totalAddonQuantity
                totalAddonQuantity = 0
            }
            return newRow

        })
        setData(newData)
    }

    const formatter = ({ value }) => {
        return <div style={{ fontSize: '1.2rem' }}>{value}</div>
    }
    const columns = useMemo(() => {
        const range = moment.range(moment(searchState.StartDate), moment(searchState.StartDate).add(days, "days"));
        const dateColumns = Array.from(range.by("day")).map(day => {
            return {
                name: day.format(dateFormat),
                title: day.format(dateFormatShort),
                formatter
            }
        })
        return [
            { name: 'Description', title: text('Description'), formatter },
            ...dateColumns
        ]
    }, [searchState.StartDate])


    const columnExtensions = useMemo(() => {
        const range = moment.range(moment(searchState.StartDate), moment(searchState.StartDate).add(days, "days"));
        const dateColumnExtensions = Array.from(range.by("day")).map(day => {
            return {
                columnName: day.format(dateFormat),
                width: 135
            }
        })
        return [
            ...dateColumnExtensions
        ]
    }, [searchState.StartDate])

    const customizeExcelHeader = worksheet => {
        const hotel = hotels.find(x => x.Id === HotelID)
        const row = worksheet.addRow([`${text("AddonsForecastReport")} ${hotel && hotel.Name}, ${moment(searchState.StartDate).format(dateFormat)} - ${moment(searchState.StartDate).add(days, "days").format(dateFormat)}`])
        worksheet.mergeCells('A1:O1');
        row.height = 20
        row.font = { bold: true, size: 16 };
    }


    const gridOptions = useMemo(() => {
        return {
            search: {
                title: text("AddonsForecastReport"),
                fields: [
                    <Form.Field control={HotelsDropDown} clearable width="4" label={text("Hotel")} key="HotelID" />,
                    <DatePicker
                        type="basic"
                        label={text("StartDate")}
                        name="StartDate"
                        key="StartDate"

                    />
                ],
                initial: {
                    "StartDate": moment().startOf("day").toDate(),
                    "HotelID": HotelID
                },
                api: GetAddonsByReservationReport,
                spec: {
                    EndDate: moment(searchState.StartDate).add(days, "days").toISOString(),
                    HotelIDs: HotelID
                },
                groupSize: 6
            },
            grid: {
                columns: columns,
                summary: true,
                export: true,
                excel: {
                    customizeHeader: customizeExcelHeader
                },
                pdf: true,
                columnExtensions: columnExtensions
            }
        }
    }, [data])

    return (<GridSearchTemplate options={gridOptions} onSearchComplete={onSearchComplete} onSearchChange={onSearchChange} data={data} />)
}

AddonsForecastReport.propTypes = {
    HotelID: PropTypes.any
}
export default AddonsForecastReport